/* Main Astra presentation bridge. Easy owns plans, prices, metadata and payment. */
(() => {
  if (window.EggRawSubscriptions) return;
  const instances = new Map();
  const subscriptionRadio = widget => widget?.querySelector('.easymsgradiobig[data-selling-plan-id]:checked');
  const selectedPlan = widget => widget?.querySelector('.easymsgsamllradio:checked') || subscriptionRadio(widget);
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const note = (parent, className, text) => {
    if (!parent || !text) return;
    let element = parent.querySelector(`.${className}`);
    if (!element) { element = document.createElement('span'); element.className = className; parent.append(element); }
    setText(element, text);
    return element;
  };

  function init(root) {
    if (instances.has(root)) return;
    const campaign = document.querySelector('[data-er-campaign]');
    const slot = root.querySelector('.er-subscription-slot');
    const form = root.querySelector('.er-native-product-form');
    if (!slot || !form) return;
    // The extension initializes on page load only. A new editor section needs one
    // real Easy instance, using the same guard and active-form reference as the app.
    const appElement = slot.querySelector('.easymanualsubsection');
    if (appElement && window.EasyManualSubscriptionSection && form._esaActiveInstance?.EMS !== appElement) {
      appElement._esaInitialized = true;
      new window.EasyManualSubscriptionSection(appElement);
    }
    const abort = new AbortController();
    const events = { signal: abort.signal };
    let previousPlan = null;
    let syncQueued = false;
    let initialChoiceApplied = false;
    let status = root.querySelector('[data-er-purchase-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'er-sr-only'; status.dataset.erPurchaseStatus = '';
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true'); form.append(status);
    }

    function sync() {
      syncQueued = false;
      const widget = slot.querySelector('.easymanualsubsection');
      const ready = !!widget?.querySelector('.easymsgradiobig');
      root.classList.toggle('er-easy-ready', ready);
      if (!ready) return;
      // Remove any legacy ETA injected by the subscription app.
      root.querySelectorAll('.er-subscription-eta:not([data-er-eta])').forEach(element => {
        clearInterval(element._erTimer);
        element.remove();
      });
      // Easy writes an inline !important divider. Remove only that visual rule.
      widget.querySelector('.easymsgsubsplanlabel')?.style.removeProperty('border-bottom');
      const group = widget.querySelector('.esaymsubscriptiongroupcontainer');
      group?.setAttribute('role', 'group');
      group?.setAttribute('aria-label', 'Purchase options');
      const subscriptionGroup = widget.querySelector('.easymsggroupcontainer');
      const firstGroup = subscriptionGroup;
      if (group && firstGroup && group.firstElementChild !== firstGroup) group.prepend(firstGroup);
      const defaultRadio = widget.querySelector('.easymsgradiobig[data-selling-plan-id]');
      if (!initialChoiceApplied && defaultRadio && !defaultRadio.disabled) {
        initialChoiceApplied = true;
        if (root.dataset.erDefaultSubscription === 'true' && !defaultRadio.checked) {
          defaultRadio.checked = true;
          defaultRadio.dispatchEvent(new Event('change', { bubbles: true }));
          window.refreshSUBX?.(); window.toggleSubscribeButton?.();
        }
      }
      const oneTime = widget.querySelector('.easymsgonetimelabel');
      setText(oneTime?.querySelector('.easywidgetheading'), root.dataset.erOnceLabel || 'One-time purchase');
      note(oneTime?.querySelector('.easymsginputcontainer'), 'er-easy-note', 'Yours, with no repeat billing.');
      root.querySelectorAll('input[data-er-variant]').forEach(input => {
        const tag = input.closest('label')?.querySelector('.er-pack-saving');
        const bottles = Number(input.dataset.bottleCount) || 0, price = Number(input.dataset.price) / 100 || 0;
        const saving = Math.round(bottles * 399 - price);
        if (tag && saving > 0 && bottles >= 4) { const sr = tag.querySelector('.er-sr-only'); tag.textContent = `Save ₹${saving.toLocaleString('en-IN')} + free delivery`; if (sr) tag.append(sr); }
      });
      const erBottles = Number((root.querySelector?.('input[data-er-variant]:checked') || document.querySelector('input[data-er-variant]:checked'))?.dataset.bottleCount) || 2;
      note(oneTime?.querySelector('.easymsgpricecontainer'), 'er-easy-price-note', 'Delivery at checkout');

      // Format only the currency label. Amounts and discounts are rendered by Easy.
      widget.querySelectorAll('.easymsgregularprice,.easymsgsubsplanprice,.easysellingplanallocationprice,.easysellingplanvariantprice').forEach(element => {
        const original = element.textContent.trim();
        setText(element, original.replace(/^Rs\.\s*/i, '₹').replace(/\.00$/, '').replace(/\d[\d,]*/, value => Number(value.replaceAll(',', '')).toLocaleString('en-IN')));
      });
      const plan = selectedPlan(widget);
      const row = plan?.closest('.easymsgsubsplanlistcontainerlabCon') || widget.querySelector('.easymsgsubsplanlistcontainerlabCon');
      const badgeText = row?.querySelector('.easydiscountbadge')?.textContent.trim();
      const headerCopy = widget.querySelector('.easymsgsubsplanlabel .easymsginputcontainer');
      const badge = note(headerCopy, 'er-easy-saving', campaign ? campaign.dataset.epSaving : 'Most popular · Save 30%');
      // Customer-first subscription copy: the plan is a habit, not a billing cycle.
      setText(headerCopy?.querySelector('.easywidgetheading'), 'Subscribe & build your habit');
      note(headerCopy, 'er-easy-note', 'Your daily protein, sorted.');
      if (!badgeText) headerCopy?.querySelector('.er-easy-saving')?.remove();
      if (badge) badge.setAttribute('aria-hidden', 'true');
      note(widget.querySelector('.easymsgsubsplanlabel .easymsgpricecontainer'), 'er-easy-price-note', campaign ? campaign.dataset.epPrepaid : 'per delivery');
      widget.classList.toggle('er-easy-single-plan', widget.querySelectorAll('.easymsgsamllradio').length === 1);
      const list = widget.querySelector('.easymsgsubsplanlistcontainer');
      const mainRadio = widget.querySelector('.easymsgradiobig[data-selling-plan-id]');
      if (mainRadio && list) {
        if (!list.id) list.id = `${campaign ? form.getAttribute('id') : form.id}-plans`;
        mainRadio.setAttribute('aria-controls', list.id);
        mainRadio.setAttribute('aria-expanded', String(!!subscriptionRadio(widget)));
      }
      // Easy states terms as "Delivery every 1 Week, prepay 4 Weeks". Cache the numbers, then
      // say it plainly ("Delivered every week" / "Billed every 4 weeks") so prepaying never surprises anyone.
      const planText = list?.textContent || '';
      const prepayMatch = planText.match(/prepay\s+(\d+)\s+weeks?/i);
      if (list && prepayMatch) {
        list.dataset.erPrepayWeeks = prepayMatch[1];
        list.dataset.erEveryWeeks = planText.match(/delivery every\s+(\d+)\s+weeks?/i)?.[1] || '1';
      }
      const everyWeeks = Number(list?.dataset.erEveryWeeks) || 1;
      const prepayWeeks = Number(list?.dataset.erPrepayWeeks) || 0;
      const deliveriesPerBill = prepayWeeks ? Math.max(1, Math.round(prepayWeeks / everyWeeks)) : 0;
      list?.querySelectorAll('*').forEach(element => {
        if (element.children.length) return;
        const terms = element.textContent.trim().match(/^delivery every\s+(\d+)\s+weeks?(?:,\s*prepay\s+(\d+)\s+weeks?)?$/i);
        if (!terms) return;
        const every = Number(terms[1]);
        setText(element, terms[2] ? `Billed every ${terms[2]} weeks` : every === 1 ? 'Delivered every week' : `Delivered every ${every} weeks`);
      });

      const subscription = !!subscriptionRadio(widget);
      subscriptionGroup?.classList.toggle('er-easy-subscription-active', subscription);
      const perks = (parent, className, lines, visible) => {
        if (!parent) return;
        let list = parent.querySelector(`.${className}`);
        if (!list) { list = document.createElement('ul'); list.className = `er-easy-perks ${className}`; parent.append(list); }
        if (list.dataset.copy !== lines.join('|')) {
          list.replaceChildren(...lines.map(text => {
            const item = document.createElement('li');
            // "Pause or cancel" links to the product page toggle that explains pause, skip and cancel.
            if (/pause|cancel/i.test(text) && document.querySelector('details.er-flex-plan')) {
              const link = document.createElement('a');
              link.href = '#pause-skip-cancel'; link.className = 'er-perk-link'; link.textContent = text;
              link.setAttribute('aria-label', `${text}: see how pausing, skipping and cancelling works`);
              item.append(link);
            } else item.textContent = text;
            return item;
          }));
          list.dataset.copy = lines.join('|');
        }
        list.hidden = !visible;
      };
      const planName = plan?.dataset.sellingPlanName || '';
      const subscriptionPrice = (row?.querySelector('.easysellingplanallocationprice') || widget.querySelector('.easymsgsubsplanprice'))?.textContent.trim();
      const toNumber = value => Number(String(value || '').replace(/[^0-9.]/g, '')) || 0;
      const billTotal = toNumber(subscriptionPrice);
      const oneTimePrice = toNumber(widget.querySelector('.easymsgregularprice')?.textContent);
      // Saving per bill versus buying the same pack one-time every week, including the ₹29 one-time delivery on Pack of 2.
      const onceDelivery = erBottles >= 4 ? 0 : 29;
      const billSaving = deliveriesPerBill && billTotal && oneTimePrice ? Math.round((oneTimePrice + onceDelivery) * deliveriesPerBill - billTotal) : 0;
      const subscriptionBenefits = [
        billSaving > 0 ? `Save ₹${billSaving.toLocaleString('en-IN')} every ${prepayWeeks} weeks + free delivery` : '30% off + free chilled delivery',
        'Skip, pause or cancel anytime',
        'No surprise debits. Alert before every renewal',
        '30-day money-back guarantee'
      ];
      widget.querySelectorAll('.easysellingplannametext').forEach(element => {
        const label = element.textContent.trim();
        if (/free shipping|pause or cancel/i.test(label)) setText(element, label.split(' · ')[0]);
      });
      perks(subscriptionGroup, 'er-easy-subscribe-perks', subscriptionBenefits, subscription);
      perks(widget.querySelector('.easymsgonetimecontainer'), 'er-easy-once-perks', ['Delivery charged at checkout', 'Full price, every order'], !subscription);
      const rawPrice = (subscription ? row?.querySelector('.easysellingplanallocationprice') || widget.querySelector('.easymsgsubsplanprice') : widget.querySelector('.easymsgregularprice'))?.textContent.trim();

      const price = rawPrice?.replace(/\d[\d,]*(?:\.\d+)?/, value => Math.round(Number(value.replaceAll(',', ''))).toLocaleString('en-IN'));
      const subscriptionLabel = widget.querySelector('.easymsgsubsplanlabel');
      if (subscriptionGroup && subscriptionLabel) {
        let priceCard = subscriptionGroup.querySelector('.er-subscription-price-card');
        if (!priceCard) {
          priceCard = document.createElement('div');
          priceCard.className = 'er-subscription-price-card';
          priceCard.innerHTML = '<div class="er-subscription-price-main"><s data-er-mrp style="opacity:.55;font-weight:600;margin-right:6px"></s><strong data-er-weekly-price></strong><span data-er-per-label>/ week</span></div><div class="er-subscription-price-day" data-er-day style="font-size:.85em;font-weight:700"></div><div class="er-subscription-price-total"><strong data-er-weekly-total></strong> <span data-er-total-label>/ month</span></div>';
          subscriptionLabel.append(priceCard);
        }
        priceCard.hidden = false;
        priceCard.removeAttribute('aria-hidden');
        const perDelivery = billTotal ? billTotal / (deliveriesPerBill || 4) : 0;
        const priceOptions = {maximumFractionDigits: 0};
        const weeklyDisplay = perDelivery ? '₹' + Math.round(perDelivery).toLocaleString('en-IN', priceOptions) : '';
        const monthlyDisplay = billTotal ? '₹' + Math.round(billTotal).toLocaleString('en-IN', priceOptions) : '';
        setText(priceCard.querySelector('[data-er-weekly-price]'), weeklyDisplay);
        setText(priceCard.querySelector('[data-er-weekly-total]'), monthlyDisplay);
        const mrpPack = erBottles * 399;
        const mrpEl = priceCard.querySelector('[data-er-mrp]'); if (mrpEl) { setText(mrpEl, perDelivery && everyWeeks === 1 ? '₹' + mrpPack.toLocaleString('en-IN') : ''); mrpEl.setAttribute('aria-label', 'Regular price ₹' + mrpPack.toLocaleString('en-IN')); }
        const dayEl = priceCard.querySelector('[data-er-day]'); if (dayEl) setText(dayEl, perDelivery && everyWeeks === 1 ? '≈ ₹' + Math.round(perDelivery / 7).toLocaleString('en-IN') + ' a day' : '');
        setText(priceCard.querySelector('[data-er-per-label]'), everyWeeks === 1 ? '/ week' : '/ delivery');
        setText(priceCard.querySelector('[data-er-total-label]'), prepayWeeks ? `for ${prepayWeeks} weeks` : '/ month');
        const onceBox = widget.querySelector('.easymsgonetimecontainer');
        if (onceBox) {
          let nudge = onceBox.querySelector('.er-once-switch');
          if (!nudge) {
            nudge = document.createElement('button');
            nudge.type = 'button'; nudge.className = 'er-once-switch';
            nudge.addEventListener('click', event => {
              event.preventDefault(); event.stopPropagation();
              const radio = widget.querySelector('.easymsgradiobig[data-selling-plan-id]');
              if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); window.refreshSUBX?.(); window.toggleSubscribeButton?.(); }
            });
            onceBox.append(nudge);
          }
          const perSaving = oneTimePrice && perDelivery ? Math.round(oneTimePrice - perDelivery) : 0;
          const nudgeTitle = perSaving > 0 ? `Switch & save ₹${perSaving.toLocaleString('en-IN')} ${everyWeeks === 1 ? 'a week' : 'a delivery'}` : 'Switch to Subscribe & Save';
          const nudgeDetail = weeklyDisplay ? `${weeklyDisplay}${everyWeeks === 1 ? '/week' : '/delivery'} · free delivery · cancel anytime` : '30% off + free delivery';
          if (nudge.dataset.copy !== nudgeTitle + nudgeDetail) {
            const main = document.createElement('span'); main.className = 'er-once-switch-main'; main.textContent = nudgeTitle;
            const sub = document.createElement('span'); sub.className = 'er-once-switch-sub'; sub.textContent = nudgeDetail;
            const go = document.createElement('span'); go.className = 'er-once-switch-go'; go.setAttribute('aria-hidden', 'true'); go.textContent = '→';
            nudge.replaceChildren(main, sub, go);
            nudge.dataset.copy = nudgeTitle + nudgeDetail;
          }
          nudge.hidden = subscription;
        }
        subscriptionGroup.querySelector('.er-price-rounding-note')?.remove();
        subscriptionGroup.querySelector('.er-routine-copy')?.remove();
      }

      const button = form.querySelector('.subx__subscribe-btn');
      if (button) {
        if (!button.querySelector('[data-er-subscribe-label]')) {
          button.replaceChildren();
          const label = document.createElement('span'); label.dataset.erSubscribeLabel = ''; label.textContent = 'Start my routine';
          const separator = document.createElement('span'); separator.textContent = '—'; separator.setAttribute('aria-hidden', 'true');
          const amount = document.createElement('span'); amount.dataset.erSubscribePrice = '';
          const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          arrow.setAttribute('class', 'er-icon'); arrow.setAttribute('aria-hidden', 'true');
          const use = document.createElementNS('http://www.w3.org/2000/svg', 'use'); use.setAttribute('href', '#i-arrow-right');
          arrow.append(use); button.append(label, separator, amount, arrow);
        }
        setText(button.querySelector('[data-er-subscribe-price]'), price || '');
        button.disabled = form.querySelector('[data-er-add]')?.disabled || !plan;
        const billPeriod = prepayWeeks ? `for ${prepayWeeks} weeks` : 'per delivery';
        button.setAttribute('aria-label', `Subscribe: start my routine${price ? `, ${price} ${billPeriod}` : ''}`); button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', 'subx__cp-overlay');

        const etaHost = button.parentElement;
        if (etaHost) {
          let discount = etaHost.querySelector('.er-subscription-discount');
          if (!discount) {
            discount = document.createElement('div');
            discount.className = 'er-subscription-discount';
            discount.setAttribute('role', 'status');
            discount.innerHTML = '<div class="er-discount-line"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="m20.5 13.5-7 7-10-10V3.5h7l10 10Z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg><span>Discount auto-applied</span></div><p class="er-guarantee-note"><strong>Less than 1%</strong> of customers use our Money-Back Guarantee</p>';
          }
          let eta = etaHost.querySelector('.er-subscription-eta[data-er-eta]');
          if (!eta) {
            eta = document.createElement('div');
            eta.className = 'er-subscription-eta';
            eta.dataset.erEta = '';
            eta.setAttribute('aria-live', 'polite');
            eta.innerHTML = '<span class="er-subscription-eta-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3 2"/></svg></span><span>Order today within <strong data-er-eta-countdown>--:--</strong>, you\'ll receive your package between <strong data-er-eta-range>—</strong></span>';
          }
          button.insertAdjacentElement('afterend', eta);
          eta.insertAdjacentElement('afterend', discount);
          discount.hidden = !subscription;
          eta.hidden = !subscription;
          const tick = () => {
            const now = new Date();
            const end = new Date(now);
            end.setHours(24, 0, 0, 0);
            const totalSeconds = Math.max(0, Math.floor((end - now) / 1000));
            const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
            const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
            const countdown = eta.querySelector('[data-er-eta-countdown]');
            if (countdown) countdown.textContent = totalSeconds > 0 ? `${hours} h ${minutes} min` : '00 h 00 min';
            const start = new Date(now);
            start.setDate(start.getDate() + 3);
            const deliveryEnd = new Date(start);
            deliveryEnd.setDate(deliveryEnd.getDate() + 1);
            const format = date => date.toLocaleDateString('en-IN', {day:'2-digit', month:'2-digit', year:'numeric'});
            const range = eta.querySelector('[data-er-eta-range]');
            if (range) range.textContent = `${format(start)} to ${format(deliveryEnd)}`;
          };
          tick();
          clearInterval(eta._erTimer);
          eta._erTimer = setInterval(tick, 60000);
        }
      }
      const pack = root.querySelector('[data-er-variant]:checked')?.nextElementSibling?.textContent.trim();
      const summary = `${pack || ''} · ${price || ''}${subscription ? (prepayWeeks ? ` for ${prepayWeeks} weeks` : ' per delivery') : ''}`;
      setText(root.querySelector('[data-er-quick-summary]'), summary);
      setText(status, `${summary}. ${subscription ? plan?.dataset.sellingPlanName || 'Subscription' : 'One-time purchase'}.`);
    }
    const schedule = () => {
      if (syncQueued) return;
      syncQueued = true;
      queueMicrotask(() => { if (root.isConnected) sync(); });
    };
    const observer = new MutationObserver(schedule);
    observer.observe(slot, { childList: true, subtree: true, characterData: true });
    slot.addEventListener('change', schedule, events);
    root.addEventListener('eggraw:variant:before', () => {
      const widget = slot.querySelector('.easymanualsubsection');
      previousPlan = subscriptionRadio(widget) ? selectedPlan(widget)?.dataset.sellingPlanId : null;
    }, events);
    root.addEventListener('eggraw:variant:change', () => {
      const widget = slot.querySelector('.easymanualsubsection');
      if (previousPlan) {
        const options = [...widget.querySelectorAll('.easymsgsamllradio')];
        const samePlan = options.find(input => input.dataset.sellingPlanId === previousPlan) || widget.querySelector('.easymsgradiobig[data-selling-plan-id]');
        if (samePlan) { samePlan.checked = true; samePlan.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      previousPlan = null;
      window.refreshSUBX?.(); window.toggleSubscribeButton?.();
      schedule();
    }, events);
    // Enter / requestSubmit must never send a selected manual subscription to Shopify's one-time checkout.
    form.addEventListener('submit', event => {
      if (!subscriptionRadio(slot.querySelector('.easymanualsubsection'))) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const button = form.querySelector('.subx__subscribe-btn');
      if (window.SUBXCheckoutPopup && button && !button.disabled) button.click();
      else {
        const error = form.querySelector('[data-er-error]');
        if (error) { error.hidden = false; error.textContent = 'Subscription checkout is still loading. Please refresh and try again.'; }
      }
    }, { capture: true, signal: abort.signal });
    instances.set(root, { observer, abort, form });
    sync();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-er-purchase]').forEach(init);
  }
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) {
      if (!event.target.contains(root)) continue;
      instance.observer.disconnect(); instance.abort.abort();
      instance.form._esaActiveInstance?.destroy?.();
      if (window.SUBX?.SUBS_ELEMENT && root.contains(window.SUBX.SUBS_ELEMENT)) {
        window.SUBX.widgetObserver?.disconnect(); window.SUBX.variantObserver?.disconnect();
        clearTimeout(window.SUBX.variantChangeTimeout);
      }
      instances.delete(root);
    }
    window.SUBXCheckoutPopup?.close();
  });
  document.addEventListener('shopify:section:load', event => {
    // Reinitialize the real app only for the newly rendered section, then its popup adapter.
    initAll(event.target);
    if (event.target.querySelector('[data-er-purchase]')) window.initSUBX?.();
  });

  function enhancePopup() {
    const overlay = document.getElementById('subx__cp-overlay');
    if (!overlay || overlay.dataset.erEnhanced) return;
    overlay.dataset.erEnhanced = 'true';
    let returnFocus;
    const modal = overlay.querySelector('[role="dialog"]');
    modal.tabIndex = -1;
    const focusables = () => [...modal.querySelectorAll('a[href],button,input,select,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
    overlay.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const elements = focusables();
      const first = elements[0], last = elements.at(-1);
      if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    });
    overlay.querySelectorAll('.subx__cp-field input,.subx__cp-field select').forEach(input => {
      const label = modal.querySelector(`label[for="${input.id}"]`);
      if (label?.textContent.includes('*')) input.setAttribute('aria-required', 'true');
      const errorId = input.id.replace(/-(select|text)$/, '') + '-err';
      if (document.getElementById(errorId)) input.setAttribute('aria-describedby', errorId);
    });
    const globalError = document.getElementById('subx__cp-global-err');
    globalError?.setAttribute('role', 'alert');
    document.getElementById('subx__cp-submit')?.addEventListener('click', () => {
      // Easy's validation runs first. Move focus only when it has reported errors.
      const error = [...overlay.querySelectorAll('.subx__cp-field-err.subx__cp-show')][0];
      error?.closest('.subx__cp-field')?.querySelector('input:not([style*="display:none"]),select')?.focus();
    });
    // Attribute observation leaves Easy's open/close and payment handlers in control.
    new MutationObserver(() => {
      if (!overlay.hidden) {
        returnFocus = document.activeElement;
        modal.scrollTop = 0;
        document.querySelector('.page-wrapper')?.setAttribute('inert', '');
      } else {
        document.querySelector('.page-wrapper')?.removeAttribute('inert');
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('eggraw:subscription:refresh'));
      }
    }).observe(overlay, { attributes: true, attributeFilter: ['hidden'] });
    new MutationObserver(() => {
      overlay.querySelectorAll('.subx__cp-field input,.subx__cp-field select').forEach(input => {
        const error = document.getElementById(input.getAttribute('aria-describedby'));
        const invalid = !!error?.classList.contains('subx__cp-show');
        input.setAttribute('aria-invalid', String(invalid));
        input.classList.toggle('subx__cp-invalid', invalid);
      });
    }).observe(modal, { childList: true, subtree: true, characterData: true });
  }
  function restoreSubscriptionEta() {
    const matches = [...document.querySelectorAll('body *')].filter(el => {
      // Never treat the theme's own ETA (under "Discount auto-applied") as a legacy app ETA.
      if (el.closest('[data-er-eta]')) return false;
      const text = (el.textContent || '').trim();
      return text.startsWith('Order today within') && text.includes("you'll receive your package between");
    });
    matches.forEach(el => {
      if (el.children.length && el.textContent.trim() === [...el.childNodes].filter(n => n.nodeType === 3).map(n => n.textContent).join('').trim()) return;
      el.classList.add('er-subscription-eta');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
    });
  }
  function openFlexPanel(event) {
    const link = event.target.closest('a.er-perk-link');
    if (!link) return;
    const panel = document.querySelector('details.er-flex-plan');
    if (!panel) return;
    event.preventDefault(); event.stopPropagation();
    panel.id = 'pause-skip-cancel';
    panel.open = true;
    history.replaceState(null, '', '#pause-skip-cancel');
    panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    panel.querySelector('summary')?.focus({ preventScroll: true });
  }
  if (!document.getElementById('er-perk-link-style')) {
    const style = document.createElement('style');
    style.id = 'er-perk-link-style';
    style.textContent = '.er-easy-perks a.er-perk-link{color:inherit;font-weight:inherit;text-decoration:underline dotted 1px;text-decoration-color:rgba(54,82,60,.45);text-underline-offset:3px;cursor:pointer}.er-easy-perks a.er-perk-link::after{content:" ›";font-weight:inherit;opacity:.6}.er-easy-perks a.er-perk-link:hover{color:#005748;text-decoration-style:solid;text-decoration-color:currentColor}.er-easy-perks a.er-perk-link:focus-visible{outline:2px solid #b58200;outline-offset:2px;border-radius:3px}details.er-flex-plan{scroll-margin-top:130px}.er-subscription-slot .er-easy-once-perks li::before{content:"" !important;flex:0 0 6px;width:6px;height:6px;margin-top:7px;border-radius:50%;background:#9aa69c !important}.er-once-switch{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;column-gap:10px;width:calc(100% - 32px);margin:2px 16px 14px;padding:10px 12px 10px 14px;border:1.5px dashed #18715d;border-radius:12px;background:#fffdf6;color:#183e30;font:inherit;text-align:left;cursor:pointer;transition:background .15s}.er-once-switch:hover{background:#e8f1e3;border-style:solid}.er-once-switch-main{grid-column:1;font-size:14px;font-weight:700;line-height:1.3;color:#005747}.er-once-switch-sub{grid-column:1;font-size:11px;line-height:1.35;color:#52634c}.er-once-switch-go{grid-column:2;grid-row:1/3;display:grid;place-items:center;width:30px;height:30px;border-radius:50%;background:#005747;color:#fff;font-size:15px}.er-once-switch[hidden]{display:none}.er-subscription-slot .easymsgsubsplanlabel .er-easy-note{grid-column:2;grid-row:3;max-width:34ch}.er-subscription-slot .easymsgsubsplanlabel:not(:has(.er-easy-saving)) .er-easy-note{grid-row:2}.er-subscription-slot .er-easy-saving{display:inline-flex!important;align-items:center;gap:6px;background:#ffdb00!important;color:#09291e!important;border:2px solid #09291e!important;border-radius:999px!important;padding:5px 12px!important;font-size:12px!important;font-weight:900!important;letter-spacing:.5px!important;text-transform:uppercase!important;box-shadow:3px 3px 0 #09291e!important;line-height:1.2!important;white-space:nowrap}.er-subscription-slot .easymsggroupcontainer.er-easy-subscription-active{border:2px solid #005747!important;box-shadow:0 0 0 4px #ffdb0066!important}';
    document.head.append(style);
  }
  document.addEventListener('click', openFlexPanel, true);
  const start = () => {
    initAll();
    enhancePopup();
    restoreSubscriptionEta();
    const bodyObserver = new MutationObserver(restoreSubscriptionEta);
    if (document.body) bodyObserver.observe(document.body, { childList:true, subtree:true });
  };
  window.EggRawSubscriptions = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
